// Dependencies
import React, {useEffect, useState} from "react";
import {useIntl} from "react-intl";
import {Grid} from '@mui/material';
// Components
import './index.scss';
import {Pill, ToggleSwitch} from 'Components';
import TagsManage from 'Modules/.common/components/TagsManage';

const TriggerLandmark = (props) => {
    const {config, triggers, onChange, triggersRaw, showErrorTrigger} = props;
    const {messages} = useIntl();

    const [landmarkTrigger, setLandmarkTrigger] = useState(false)
    const [landmark, setLandmark] = useState([])

    const insideLandmark = {id: "InsideLandmark", name: messages["alertsNewAlert_insideLandmark"]}
    const outsideLandmark = {id: "OutsideLandmark", name: messages["alertsNewAlert_outsideLandmark"]}
    const [typeLandmarkTrigger, setTypeLandmarkTrigger] = useState(insideLandmark.id)

    const landmarkEntity = { id: "Landmark", label: messages['alertsNewAlert_landmarks'] || "Landmarks" };

    useEffect(() => {
        if (config?.trigger) {
            setLandmarkTrigger(true);
            setTypeLandmarkTrigger(config.trigger);
            
            if (triggersRaw && triggersRaw.length > 0) {
                setLandmark(triggersRaw);
            } else if (triggers && triggers.length > 0) {
                const landmarksData = triggers.map((item) => item?.entity ?? item);
                setLandmark(landmarksData);
            }
        }
    }, [config?.trigger, triggersRaw, triggers]);

    return (
        <>
            {/* Hidden for EVIRPX-557: Hide toggle for InspectionDuration */}
            {config?.triggerType !== 'InspectionDuration'
            && config?.triggerType !== 'InspectionStatus'
            && config?.triggerType !== 'InspectionDefects'
            && (
                <div style={{paddingTop: "20px", width: "100%"}}>
                    <ToggleSwitch
                        id="evaluateLandmarkTrigger"
                        small
                        blueToggle
                        optionLabels={["", ""]}
                        label={messages['alertsNewAlert_evaluateLandmarkTrigger']}
                        checked={landmarkTrigger}
                        onChange={(event) => {
                            setLandmarkTrigger(event)
                            const landmarks = triggersRaw ?? triggers?.map((item) => item?.entity ?? item) ?? [];
                            setLandmark(landmarks)
                            onChange({...config, trigger: event ? typeLandmarkTrigger : null}, landmarks)
                        }}
                    />
                </div>
            )}
            {
                showErrorTrigger && landmarkTrigger &&
                <div className="text-danger">
                    {messages["alertsNewAlert_triggerValidationLandmarks"]}
                </div>
            }
            {
                landmarkTrigger && <>
                    <Grid
                        style={{paddingTop: "20px", width: "100%"}}
                        container
                        direction="row"
                        alignItems="center"
                        spacing={1}
                        color="primary"
                        aria-label="outlined primary button group"
                    >
                        <Grid item sm={6}>
                            <Pill
                                textField={'name'}
                                item={insideLandmark}
                                outlined={typeLandmarkTrigger !== insideLandmark.id}
                                onClick={(entity) => {
                                    setTypeLandmarkTrigger(entity.id)
                                    onChange({...config, trigger: entity.id}, landmark)
                                }}
                                style={{border: '0', margin: '2px 0', width: '100%'}}
                                label="pill-label-text"
                                colorField="default"
                                colorSelection="005bf8"
                            />
                        </Grid>
                        <Grid item sm={6}>
                            <Pill
                                textField={'name'}
                                item={outsideLandmark}
                                outlined={typeLandmarkTrigger !== outsideLandmark.id}
                                onClick={(entity) => {
                                    setTypeLandmarkTrigger(entity.id)
                                    onChange({...config, trigger: entity.id}, landmark)
                                }}
                                style={{border: '0', margin: '2px 0', width: '100%'}}
                                label="pill-label-text"
                                colorField="default"
                                colorSelection="005bf8"
                            />
                        </Grid>
                    </Grid>
                    <div style={{width: "100%"}}>
                           <TagsManage
                                entities={[landmarkEntity]}
                                entitySelected={landmarkEntity}
                                enableSelectAll={false}
                                disableUntaggedSelection={true}
                                height={240}
                                label={messages["unit_settings_tags_simple"]}
                                placeholder={messages["unit_settings_tags_search"]}
                                required={true}
                                value={landmark || []}
                                onChange={(items) => {
                                    setLandmark(items)
                                    if (items.length) {
                                        onChange({...config, trigger: typeLandmarkTrigger}, items)
                                    } else {
                                        onChange({...config}, [])
                                    }
                                }}
                                menuStyle={{ maxHeight: '280px', maxWidth: '620px' }}

                            />
                    </div>
                </>
            }
        </>
    )
}

export default TriggerLandmark;
